import { useQuery } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { analyticsApi } from 'src/services/analyticsApi'
import {
  OverviewResponse,
  UseGetOverviewParams,
} from './interfaces/useGetOverviewQuery.interface'

const getOverview = async (
  start?: string,
  end?: string
): Promise<OverviewResponse | null> => {
  const { data } = await analyticsApi().get<OverviewResponse>(
    '/v1_private/analytics/overview',
    {
      params: {
        fromDate: start,
        toDate: end,
      },
    }
  )

  return data
}

export const useGetOverviewQuery = (params: UseGetOverviewParams) => {
  return useQuery({
    queryFn: () => getOverview(params.start, params.end),
    queryKey: [QueryKey.GET_OVERVIEW, ...Object.values(params)],
  })
}
